/* eslint-disable */
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'
import axios from 'axios'
import moment from 'moment';

Vue.use(VueRouter)

const router = new VueRouter({
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [
        {
            path: '/',
            name: 'Home',
            component: () =>
                import ('@/views/projects.vue'),
            meta: {
                pageTitle: 'Welcome back',
                pageSubTitle: '',
                requiresAuth: true,
            },
          }, 
          {
            path: '/projects',
            name: 'Projects',
            component: () =>
                import ('@/views/projects.vue'),
            meta: {
                pageTitle: 'Projects',
                // pageSubTitle: 'Project List',
                requiresAuth: true,
                breadcrumb: [{
                    text: 'Projects',
                    active: true
                }],
            },
          }, 
       //  {
        //    path: '/projects/:id',
         //   name: 'Project',
        //    component: () =>
         //       import ('@/views/project.vue'),
        //    meta: {
        //        pageTitle: 'Project',
                // pageSubTitle: 'Project List',
        //        requiresAuth: true,
       //         breadcrumb: [{
        //            text: 'Projects',
         //           active: false,
          //          to: '/projects'
          //      },{
         //           text: 'Project',
         //           active: true
         //       }],
        //    },
       //   }, 
         { path: '/projects/:id', redirect: '/projects/:id/experimental' },
       //  { path: '/projects/:id', redirect: '/projects/:id/viewers' },
      {
            path: '/projects/:id/processing',
            name: 'Image Processing',
            component: () =>
                import ('@/views/projectProcess.vue'),
            meta: {
                pageTitle: 'Image Processing',
                // pageSubTitle: 'Project List',
                requiresAuth: true,
                breadcrumb: [{
                    text: 'Projects',
                    active: false,
                    to: '/projects'
                },{
                    text: 'Project',
                    active: false,
                    to: '/projects/'
                },{
                    text: 'Process',
                    active: true
                }],
            },
          },
          {
            path: '/projects/:id/downstream',
            name: 'Downstream Analysis',
            component: () =>
                import ('@/views/DownstreamAnalysis.vue'),
            meta: {
                pageTitle: 'Downstream Analysis',
                // pageSubTitle: 'Project List',
                requiresAuth: true,
                breadcrumb: [{
                    text: 'Projects',
                    active: false,
                    to: '/projects'
                },{
                    text: 'Project',
                    active: false,
                    to: '/projects/'
                },{
                    text: 'Downstream Analysis',
                    active: true
                }],
            },
          }, 
          {
            path: '/projects/:id/experimental',
            name: 'Experimental Design',
            component: () =>
                import ('@/views/ExpDesign.vue'),
            meta: {
                pageTitle: 'Image Processing',
                // pageSubTitle: 'Project List',
                requiresAuth: true,
                breadcrumb: [{
                    text: 'Projects',
                    active: false,
                    to: '/projects'
                },{
                    text: 'Project',
                    active: false,
                    to: '/projects/'
                },{
                    text: 'Experimental Design',
                    active: true
                }],
            },
          }, 
          {
            path: '/projects/:id/viewers',
            name: 'Viewers',
            component: () =>
                import ('@/views/viewers/index.vue'),
            meta: {
                pageTitle: 'Viewers',
                // pageSubTitle: 'Project List',
                requiresAuth: true,
                breadcrumb: [{
                    text: 'Projects',
                    active: false,
                    to: '/projects'
                },{
                    text: 'Project',
                    active: false,
                    to: '/projects/'
                },{
                    text: 'Viewers',
                    active: true
                }],
            },
          }, 
         /* {
            path: '/projects/:id/viewers/:viewer',
            name: 'Viewers',
            component: () =>
                import ('@/views/viewers/index.vue'),
            meta: {
                pageTitle: 'ViewerTab',
                // pageSubTitle: 'Project List',
                requiresAuth: true,
                breadcrumb: [{
                    text: 'Projects',
                    active: false,
                    to: '/projects'
                },{
                    text: 'Project',
                    active: false,
                    to: '/projects/'
                },{
                    text: 'Viewers',
                    active: true
                }],
            },
          }, */
          {
            path: '/users',
            name: 'Users',
            component: () =>
                import ('@/views/users.vue'),
            meta: {
                pageTitle: 'Users',
                // pageSubTitle: 'Project List',
                requiresAuth: true,
                breadcrumb: [{
                    text: 'User List',
                    active: true
                }],
            },
          }, 
        {
            path: '/sign-in',
            name: 'Login',
            component: () =>
                import ('@/views/Login.vue'),
            meta: {
                pageTitle: 'MILAN',
                layout: 'full',
                requiresAuth: false,
            },
          }, 
        {
            path: '/error-404',
            name: 'error-404',
            component: () =>
                import ('@/views/error/Error404.vue'),
            meta: {
                layout: 'full',
            },
        }
    ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = 'none'
    }
})

router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('sessionToken')
      const { url, port, auth } = store.state.appConfig.api
      const headers = {
        authentication: auth,
        'Content-Type': 'application/json',
      } 
    if (to.matched.some(record => record.meta.requiresAuth)) {
        axios.get(`${url}:${port}/user/${token}`, { headers }).then(result => {
    if (result.data.error) {   
        next({ name: 'Login' })
      } else {
        const userdata = result.data.userdata
        const name = (userdata.name + ' ' + userdata.lastname).trim()
        if (to.name === 'Home') { 
            to.meta.pageSubTitle = name 
            to.meta.pageTitle = hello()
        } 
        next() 
      }
    })
    } else {
      next() 
    }
  })

  function hello(){
    const hour = moment().hour();
    let greeting
    if (hour >= 22){
        greeting = 'Good night'
    } else  if (hour >= 18){
        greeting = 'Good evening'
    } else  if (hour >= 12){
        greeting = 'Good afternoon'
    } else  if (hour >= 5){
        greeting = 'Good morning'
    } else {
        greeting = 'Good night'
    }
    return greeting
  }

export default router